/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Traffic_HintInputs */



/**
* | output |
* | --- |
* | "Replace any existing A or AAAA records on the domain — a leftover record from a previous host makes the certificate fail intermittently." |
*
* @param {Canvas_Domain_Traffic_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_traffic_hint = /** @type {((inputs?: Canvas_Domain_Traffic_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Traffic_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzen Sie vorhandene A- oder AAAA-Einträge der Domain — ein übrig gebliebener Eintrag des vorherigen Anbieters lässt die Zertifikatsausstellung zeitweise fehlschlagen.")
	return /** @type {LocalizedString} */ ("Replace any existing A or AAAA records on the domain — a leftover record from a previous host makes the certificate fail intermittently.")
});